import LocalStorageHelper from '@/utils/LocalStorageHelper';

export const PRODUCT_TAG_STORED_CONSTANT = 'PRODUCT_TAG_STORED_CONSTANT';

const EMPTY_DATA = {
  allowReset: true,
  categoryItems: [],
  currentCategoryId: null,
};

export const getCachedCategoryItems = () => {
  return LocalStorageHelper.get(PRODUCT_TAG_STORED_CONSTANT) || EMPTY_DATA;
};

export const cacheCategoryItems = (data) => {
  const currentData = getCachedCategoryItems();
  const updatedData = { ...currentData, ...data };
  LocalStorageHelper.add(PRODUCT_TAG_STORED_CONSTANT, updatedData);
};

export const clearCachedItems = () => {
  cacheCategoryItems(EMPTY_DATA);
};
